/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged } from 'rxjs';

export function debouncedSignal<T>(s : Signal<T>): Signal<T> {

  const obs = toObservable(s);
  const debounced = obs.pipe(
    distinctUntilChanged((prev, curr) => jsonCompareFn(prev, curr)),
    debounceTime(300)
  );

  const debouncedSignal = toSignal(debounced, {initialValue: s()});

  const jsonCompareFn = (a: unknown, b: unknown): boolean =>  {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  return debouncedSignal;
}
